import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function WearableSensorsUseCase() {
  return (
    <>
    <section
      id="wearable-sensors"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Wearable Organic Sensors
          </h1>
          <p className="text-slate-300 space-y-2">
            Wearable sensors are enabling a new generation of real-time, non-invasive health monitoring — from heart rate and hydration to respiration and chemical biomarkers. 
            Organic electronic materials play a pivotal role in this evolution by offering mechanical softness, skin conformability, and low-temperature processability. 
            They allow for sensors that are flexible, stretchable, lightweight, and unobtrusive enough to be integrated into textiles, patches, or even temporary tattoos.

            <br /><br />

            These sensors are central to the rise of virtual wards, where patients are monitored remotely after discharge, reducing hospital burden while improving care continuity. 
            Accurate and responsive materials are essential to making this vision scalable, especially for sensing volatile organic compounds, sweat metabolites, or subtle pressure changes over time.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Evaluate HOMO/LUMO levels, reorganisation energy, and spectral response.
    </li>
    <li>
      Screen for flexible organic materials with high charge mobility and environmental stability.
    </li>
    <li>
      Explore solubility and skin-contact suitability via integrated toxicity flags.
    </li>
    <li>
      Select and purchase viable candidates and alternatives based on core scaffolds.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Many wearable sensor concepts never reach real-world deployment due to material limitations or slow iteration cycles.
            DiaDEM™ accelerates the discovery of responsive, skin-compatible materials tailored to specific sensing functions — unlocking faster prototyping and greater impact in digital health, sports science, and remote care.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
